import React from "react";
import { Container, Navbar, Row, Col, CloseButton } from "react-bootstrap";
import { useHistory } from "react-router";
import { useSelector } from "react-redux";
import "../HRM/HRM.css";
import "./EventLogPage.css";

const LogHeader = ({ eventType }) => {
  const history = useHistory();
  const interval = useSelector((state) => state?.globalFilters?.interval);

  return (
    <div>
      <Navbar className="header-hrm">
        <Container fluid className="px-0">
          <Row className="header-hrm-row w-100 align-items-center">
            <Col xs={12} sm={7} md={7} lg={4}>
              <div className="header-brand">
                <div className="header-brand-icon">
                  <img
                    src="/images/dashboard/hme.png"
                    alt="UMV"
                  />
                </div>
                <div>
                  <span className="header-text">
                    {eventType === "am"
                      ? "Motion Monitoring Logs"
                      : eventType === "hrm"
                        ? "Heart Rate Monitoring Logs"
                        : eventType === "fd"
                          ? "Fall Detection Logs"
                          : "Logs"}
                  </span>
                </div>
              </div>
            </Col>
            <Col xs={12} sm={5} md={5} lg={8}>
              <div className="header-actions">
                <h5 className="event-days">{interval}</h5>
                <CloseButton
                  style={{ opacity: "1" }}
                  variant="white"
                  aria-label="Hide"
                  onClick={() => history.goBack()}
                />
              </div>
            </Col>
          </Row>
        </Container>
      </Navbar>
    </div>
  );
};

export default LogHeader;
